document.querySelectorAll('section[data-slider]').forEach(section => {
  const items   = Array.from(section.querySelectorAll('.x-slider-item'));
  const bullets = Array.from(section.querySelectorAll('.x-slider-bullets-content .bullet'));

  if (!items.length) return;

  let currentIndex = 0;

  function goTo(index) {
    items.forEach(item => item.classList.remove('open'));
    bullets.forEach(b => b.classList.remove('current'));
    items[index].classList.add('open');
    if (bullets[index]) bullets[index].classList.add('current');
    currentIndex = index;
  }

  bullets.forEach((bullet, index) => {
    bullet.addEventListener('click', () => {
      goTo(index);
      resetAutoplay();
    });
  });

  const autoplayMs = parseInt(section.getAttribute('data-autoplay'), 10);
  let timer = null;

  function startAutoplay() {
    timer = setInterval(() => goTo((currentIndex + 1) % items.length), autoplayMs);
  }

  function stopAutoplay() {
    clearInterval(timer);
  }

  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  if (autoplayMs > 0) {
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('touchstart', stopAutoplay, { passive: true });
    section.addEventListener('touchend', startAutoplay, { passive: true });
    startAutoplay();
  }
});
